// extracted by mini-css-extract-plugin
module.exports = {"actionList":"AnnotationActions_actionList__2qXtc","action":"AnnotationActions_action__2Q46a"};